import { jsonProperty, Serializable, SerializationSettings } from 'ts-serializable';

interface IComponentGameMemoryCard {
    codigo: number;
    filepath: string;
    base64: string;
    relationCardNumber: number;
}

class ComponentGameMemoryCard extends Serializable {
    @jsonProperty(Number)
    codigo: number = -1;

    @jsonProperty(String)
    filepath: string = '';

    @jsonProperty(String)
    base64: string = '';

    @jsonProperty(Number)
    relationCardNumber: number = -1;

    fromJSON(json: IComponentGameMemoryCard, settings?: Partial<SerializationSettings>): this {
        this.codigo = json.codigo;
        this.filepath = json.filepath;
        this.base64 = json.base64;
        this.relationCardNumber = json.relationCardNumber;

        return this;
    }
}

export default ComponentGameMemoryCard;
